import React from 'react';
import './Event_about.css';

const Event_about = () => {
    const state = {
        FourKeys_item: [
            {
                title: 'Major updates',
                topics: [
                    'react-codemirror2 npm package for writing code in the notes',
                    'Building Machine Learning Web Applications Using ReactJs',
                    'React v18.0',
                    'Dealing With CORS in CRA',
                    'Deprecated/discouraged: ReactDOM.render, renderToString',
                ],
            },
            {
                title: 'Components',
                topics: [
                    'Creating Mobile Responsive Components',
                    'Next steps for getDerviedStateFromProps',
                    'Embrace Single-Page Applications (SPA)',
                ],
            },
            {
                title: 'API',
                topics: [
                    'API: reateRoot, hydrateRoot, renderToPipeableStream, renderToReadableStream',
                    'A deep dive into React Fiber internals',
                    'Automatic Batching',
                ],
            },
            {
                title: 'UI design kit',
                topics: [
                    'ReactJS UI Ant Design Other Component',
                    'Building Dashboard Apps With React',
                ],
            },
        ],
    };

    const renderGetReady = (item, i) => {
        return (
            <div className="getReady_item" key={`getReady_item-${i}`}>
                <div className='getReady_item--title_block'>
                    <h3 className='getReady_item--title'>{item.title}</h3>
                </div>
                <ul className='getReady_ul'>
                    {item.topics.map(item => <li className='getReady_li p2' key={`getReady_li-${i + item}`}><span>[]</span> {item}</li>)}
                </ul>
            </div>
        );
    };

    return (
        <div className='getReady_wrap'>
            <div className='container getReady'>
                <h2 className='getReady_title colorful'>&lt;What event is about&gt;</h2>
                <div className='getReady_block'>
                    {state.FourKeys_item.map((item, i) => renderGetReady(item, i))}
                </div>
            </div>
        </div>
    );
};

export default Event_about;